export const APP_WIDTH = 640;
export const COLLECTS_PER_SECOND = 4;
export const UPGRADE_PRICE = 300000;
export const UPGRADE_RATE = 2.2 / 10; // seconds/token
export const UPGRADE_BONUS = 2; // resource/second/upgrade
export const INIT_COLLECT = 0;
export const INIT_TARGET = 0;
export const INIT_WALKTIME = 0;
export const VARIANTS = ['primary', 'warning', 'danger'];
export const STACK_OPTIONS = [2, 200, 2000, 20000, 200000, 2000000];
export const NUM_RESULTS = 3;
